<script>
export default {
  name: 'ClaimStatus',
  page: {
    title: 'Claim Status',
  },
  props: {
    value: {
      type: String,
      required: true,
      validate: value => /created|code_sent|failed|redeemed|revoked/
        .test(String(value).toLowerCase()),
    },
    frozen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    icon() {
      if (this.frozen) return 'time'
      switch (String(this.value).toLowerCase()) {
        case 'created': return 'time'
        case 'code_sent': return 'time'
        case 'failed': return 'error'
        case 'redeemed': return 'success'
        case 'revoked': return 'error'
        default: return 'warning'
      }
    },
    color() {
      switch (String(this.value).toLowerCase()) {
        case 'created': return 'orange'
        case 'code_sent': return 'orange'
        case 'failed': return 'red'
        case 'redeemed': return 'green'
        case 'revoked': return 'red'
        default: return 'default'
      }
    },
    label() {
      if (this.frozen) return 'Frozen'
      switch (String(this.value).toLowerCase()) {
        case 'code_sent': return 'Code sent'
        case 'created': return 'Pending'
        case 'failed':
        case 'redeemed':
        case 'revoked':
        default:
          return this.value
      }
    },
  },
}
</script>

<template>
  <div :class="$style[color]">
    <el-icon
      :class="$style.icon"
      :name="icon"
    />
    <span :class="$style.capitalize">
      {{ label }}
    </span>
  </div>
</template>

<style lang="scss" module>
  .icon {
    margin-right: 5px;
  }
  .capitalize {
    text-transform: capitalize;
  }
  .default {
    color: inherit;
  }
  .green {
    color: #0ed067;
  }
  .orange {
    color: #fe9f1e;
  }
  .red {
    color: #ff4849;
  }
</style>
